import { Routes, Route, Navigate } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { AdminRoute } from "@/components/auth/AdminRoute";
import { RequireAuth } from "@/components/auth/RequireAuth";
import { LoginPage } from "@/pages/Login";
import { AuthCallbackPage } from "@/pages/AuthCallback";
import { DashboardPage } from "@/pages/Dashboard";
import { LeadsLayout } from "@/pages/Leads";
import { LeadsList } from "@/pages/Leads/List";
import { LeadsMap } from "@/pages/Leads/Map";
import { LeadsImport } from "@/pages/Leads/Import";
import { RoutesLayout } from "@/pages/Routes";
import { RoutesAll } from "@/pages/Routes/All";
import { RoutesPlan } from "@/pages/Routes/Plan";
import { RoutesMap } from "@/pages/Routes/Map";
import { RouteDetail } from "@/pages/Routes/Detail";
import { SettingsLayout } from "@/pages/Settings";
import { SettingsProfile } from "@/pages/Settings/Profile";
import { SettingsOrganization } from "@/pages/Settings/Organization";
import { SettingsPlan } from "@/pages/Settings/Plan";
import { TeamPage } from "@/pages/Team";
import { OnboardingMfaPage } from "@/pages/OnboardingMfa";
import {
  ActivityLayout,
  ActivitySignIns,
  ActivityUploads,
  ActivityExports,
} from "@/pages/Activity";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route element={<RequireAuth />}>
        {/* MFA enrollment route is intentionally outside AppShell because
            AppShell itself redirects authed users without MFA here. */}
        <Route path="/onboarding/mfa" element={<OnboardingMfaPage />} />
        <Route element={<AppShell />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />

        <Route path="/leads" element={<LeadsLayout />}>
          <Route index element={<LeadsList />} />
          <Route path="map" element={<LeadsMap />} />
          <Route element={<AdminRoute />}>
            <Route path="import" element={<LeadsImport />} />
          </Route>
        </Route>

        <Route path="/routes" element={<RoutesLayout />}>
          <Route index element={<RoutesAll />} />
          <Route element={<AdminRoute />}>
            <Route path="plan" element={<RoutesPlan />} />
            <Route path="map" element={<RoutesMap />} />
          </Route>
          <Route path=":id" element={<RouteDetail />} />
        </Route>

        <Route path="/settings" element={<SettingsLayout />}>
          <Route index element={<Navigate to="/settings/profile" replace />} />
          <Route path="profile" element={<SettingsProfile />} />
          <Route element={<AdminRoute />}>
            <Route path="organization" element={<SettingsOrganization />} />
            <Route path="plan" element={<SettingsPlan />} />
          </Route>
        </Route>

        <Route element={<AdminRoute />}>
          <Route path="/team" element={<TeamPage />} />
          <Route path="/activity" element={<ActivityLayout />}>
            <Route index element={<ActivitySignIns />} />
            <Route path="uploads" element={<ActivityUploads />} />
            <Route path="exports" element={<ActivityExports />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
